/// <amd-module name="WorkItemsHub/Utils/Common" />
export interface IDisposable {
    dispose(): void;
}
